import { graphql, DataValue } from '@apollo/client/react/hoc';
import * as React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import TARGET_BY_STUDENT_ID_CONTAINER_QUERY from '../queries/TargetByStudentIdContainerQuery.gql';
import { selectStudentIdListRecipient, clearSelection } from 'reducers/roleBasedMessagingSearch';

import type {
  TargetByStudentIdContainer as QueryData,
  TargetByStudentIdContainerVariables as QueryVariables,
  TargetByStudentIdContainer_organizations as Org,
} from '../queries/__generated__/TargetByStudentIdContainer';

export type ChildrenProps = {
  loading: boolean;
  organizations?: ReadonlyArray<Org | undefined | null>;
  selectStudentIdListRecipient: typeof selectStudentIdListRecipient;
  clearSelection: () => void;
};

export type Props = {
  children: (props: ChildrenProps) => JSX.Element;
  organizationUuids: Array<string>;
  // redux dispatchers
  selectStudentIdListRecipient: typeof selectStudentIdListRecipient;
  clearSelection: () => void;
  // graphql data
  data?: DataValue<QueryData>;
};

export function TargetByStudentIdContainer(props: Props) {
  const loading = props.data?.loading || (props.data?.networkStatus ?? 7) < 7;
  const organizations = props.data?.organizations;

  return props.children({
    loading,
    organizations,
    selectStudentIdListRecipient: props.selectStudentIdListRecipient,
    clearSelection: props.clearSelection,
  });
}

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators(
    {
      selectStudentIdListRecipient,
      clearSelection,
    },
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    dispatch
  );

const withOrgs = graphql<Props, QueryData, QueryVariables>(TARGET_BY_STUDENT_ID_CONTAINER_QUERY, {
  options: ({ organizationUuids }) => ({
    variables: {
      uuids: organizationUuids,
    },
  }),
});

export default compose(
  connect(undefined, mapDispatchToProps),
  withOrgs
)(TargetByStudentIdContainer) as React.ComponentType<Pick<Props, 'children' | 'organizationUuids'>>;
